import Rest from '../Rest'

export default class ScheduleGuestService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/schedule_guests'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  confirmSchedule(scheduleSuggestionId: number, params) {
    return this.post(`/${scheduleSuggestionId}/confirm`, params).then(data => {
      return data
    })
  }

  disconfirmSchedule(scheduleSuggestionId: number, params) {
    return this.post(`/${scheduleSuggestionId}/disconfirm`, params).then(data => {
      return data
    })
  }

  confirmScheduleEncrypted(hash: string, suggestion_id: number) {
    return this.post(`/encrypted/confirm`, {hash, suggestion_id})
  }

  rejectScheduleEncrypted(hash: string, suggestion_id: number, justification = null) {
    return this.post(`/encrypted/reject`, {hash, suggestion_id, justification})
  }

  rejectEventEncrypted(hash: string, justification) {
    return this.post(`/encrypted/event/reject`, {hash, justification})
  }

}
